import { render, staticRenderFns } from "./DetalleComisionCorredor.vue?vue&type=template&id=2c04e899&"
import script from "./DetalleComisionCorredor.vue?vue&type=script&lang=js&"
export * from "./DetalleComisionCorredor.vue?vue&type=script&lang=js&"
import style0 from "./DetalleComisionCorredor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetalleComisionCorredor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VDivider,VRadio,VRadioGroup})
